import { initCounters } from '~/modules/post/utils'

/**
 *
 */
export default function countComments(comments = []) {
  /**
   *
   */
  // @ts-expect-error TS(7006) FIXME: Parameter 'labels' implicitly has an 'any' type.
  const countLabels = (labels, counters) => {
    for (const label of labels) {
      // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
      const counter = counters.labels.find((el) => el.label === label)
      if (counter) {
        counter.count++
      }
    }
  }

  /**
   *
   */
  // @ts-expect-error TS(7006) FIXME: Parameter 'comments' implicitly has an 'any' type.
  const countComments = (comments, counters) => {
    // @ts-expect-error TS(7031) FIXME: Binding element 'needsAttention' implicitly has an... Remove this comment to see the full error message
    comments.forEach(({ needsAttention, labels = [], replies = [] }) => {
      if (needsAttention) {
        counters.totalPendingComments++
        countLabels(labels, counters)
      }

      counters.totalComments++

      if (replies) {
        countComments(replies, counters)
      }
    })

    return counters
  }

  return countComments(comments, initCounters())
}
